









import { Component, Vue, Prop } from 'vue-property-decorator';

import ActivationEmailItem from '@/componentsV2/molecules/ActivationEmailItem/ActivationEmailItem.vue';

import { IActivationEmail } from '@/models/integrations-activation-emails';

@Component({
  components: {
    ActivationEmailItem
  }
})
export default class ActivationEmailList extends Vue {
  @Prop() email!: IActivationEmail;
}
